import type {
  AuthRepositoryMethods,
  EmbeddedTrustAccessTokenCredentials,
  LoginBasicControlledProcessReturnType,
} from "@/repositories/auth/types";
import { BaseRepositoryV2 } from "@/repositories/base-repository-v2";
import type { Person } from "@/repositories/people/types";

export default class AuthRepository extends BaseRepositoryV2 implements AuthRepositoryMethods {
  // It's important to declare every method here and assign them as arrow functions
  // in the constructor to avoid errors in the client components that use them.
  path: string;

  getEmbeddedTrustAccessToken;
  loginBasicControlledProcess;

  constructor() {
    super();
    this.path = "/auth";

    this.loginBasicControlledProcess = async (data: {
      password: Person["password"];
      username: Person["username"];
    }) => {
      const response = await this.post(
        `${this.path}/public/evbasic`,
        {
          password: data.password,
          username: data.username,
        },
        {},
        false
      );
      return this.toAxiosResponse<LoginBasicControlledProcessReturnType>(response);
    };

    this.getEmbeddedTrustAccessToken = async (
      data: EmbeddedTrustAccessTokenCredentials
    ): Promise<string> => {
      const baseUrl = this.baseUrl.replace(/\/+$/, "");
      const response = await fetch(`${baseUrl}/auth/public/evbasic`, {
        body: JSON.stringify(data),
        headers: await this.getHeaders(),
        method: "POST",
      });
      if (!response.ok) {
        throw new Error("Child access token request failed");
      }

      const responseData = (await response.json()) as unknown;
      if (typeof responseData !== "object" || responseData === null) {
        throw new Error("Child access token is missing");
      }

      const accessToken = (responseData as { access_token?: unknown }).access_token;
      if (typeof accessToken !== "string" || accessToken.trim().length === 0) {
        throw new Error("Child access token is missing");
      }

      return accessToken;
    };
  }
}
